import { Box } from '@material-ui/core';

import { ChannelTypeOptions } from '@/components/modules/ChannelDetail/ChannelDetails/constants/ChannelTypeOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface CreateChannelFormProps extends FormGridOptions {}

export const CreateChannelForm = ({ fullWidth, fieldVariant }: CreateChannelFormProps) => {
  return (
    <Box pt={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <TextFormField label={'CHANNEL_DESCRIPTION'} name={'description'} />
        <SelectFormField label={'CHANNEL_TYPE'} name={'type'} selectOptions={ChannelTypeOptions} />
      </FormGridContainer>
    </Box>
  );
};
